<template>
  <div class="container">
    <div class="content">
      <div class="btnBox">
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="mini">
          <!-- 组合搜索项 -->
          <el-form-item v-for="(item, index) in combinedSearchItems" :key="index">
            <div class="input-with-select" style="width: 200px;">
              <el-select v-model="item.value" clearable style="width: 80px;" class="category-select"
                @change="handleSearchTypeChange(item, index)">
                <el-option v-for="option in item.options" :key="option.value" :label="option.label"
                  :value="option.value"></el-option>
              </el-select>
              <el-input placeholder="请输入" v-model="item.keyword" @keyup.enter.native="fetchData('search')"
                style="width: 110px;"></el-input>
            </div>
          </el-form-item>

          <!-- 商品类目 -->
          <el-form-item prop="categoryId">
            <div class="input-with-select" style="height: 40px;">
              <span class="prepend-text">商品类目</span>
              <el-cascader :options="categoryList" v-model="searchForm.categoryId" :props="{ checkStrictly: true }"
                @change="onChangeCategory" filterable clearable style="width: 120px;"></el-cascader>
            </div>
          </el-form-item>

          <!-- 商品类型 -->
          <el-form-item prop="type">
            <div class="input-with-select">
              <span class="prepend-text">商品类型</span>
              <el-select v-model="searchForm.goodsTypes" placeholder="请选择" filterable clearable multiple collapse-tags
                style="width: 120px;">
                <el-option v-for="item in dictionaries.goods_type" :key="item.dictId" :label="item.dictName"
                  :value="item.dictId"></el-option>
              </el-select>
            </div>
          </el-form-item>

          <!-- 品牌 -->
          <el-form-item prop="brandId">
            <div class="input-with-select">
              <span class="prepend-text">品牌</span>
              <el-select v-model="searchForm.brandId" placeholder="请选择" filterable clearable style="width: 120px;">
                <el-option v-for="item in brandList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </div>
          </el-form-item>

          <!-- 商品来源 -->
          <el-form-item prop="origin">
            <div class="input-with-select">
              <span class="prepend-text">商品来源</span>
              <el-select v-model="searchForm.platformId" placeholder="请选择" filterable clearable style="width: 120px;">
                <el-option v-for="item in platformList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </div>
          </el-form-item>

          <!-- 查询按钮 -->
          <el-form-item class="form-buttons">
            <el-button type="primary" @click="fetchData('search')">查询</el-button>
            <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn-list">
        <div class="tab-buttons">
          <div class="tab-button" :class="{ active: currentStatus === groupByStatus.total }"
            @click="onChangeList(groupByStatus.total)">
            全部({{ countGroupByStatus.total }})
          </div>
          <div class="tab-button" :class="{ active: currentStatus === groupByStatus.up }"
            @click="onChangeList(groupByStatus.up)">
            上架中({{ countGroupByStatus.up }})
          </div>
          <div class="tab-button" :class="{ active: currentStatus === groupByStatus.down }"
            @click="onChangeList(groupByStatus.down)">
            已下架({{ countGroupByStatus.down }})
          </div>
        </div>
        <div class="item">
          <el-button @click="handleBatchExternalSetting">批量对外设置</el-button>
          <el-button v-if="parArray.indexOf('putOnCode') != -1" @click="operationStatus('up')"
            :disabled="currentStatus === groupByStatus.up ? true : false">批量上架</el-button>
          <el-button v-if="parArray.indexOf('putOffCode') != -1" @click="operationStatus('down')"
            :disabled="currentStatus === groupByStatus.down ? true : false">批量下架</el-button>
          <el-button @click="onImport">批量导入</el-button>
          <el-dropdown trigger="hover" @command="handleBatchOperation" style="padding: 0 8px;">
            <el-button :loading="GoodsExportLoading">导出商品
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="normal">导出商品</el-dropdown-item>
              <el-dropdown-item command="cost">导出商品（成本）</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="warning" plain @click="toOtherPages('goodsSyncCheck')">九航同步商品核对</el-button>
          <el-button type="primary" plain @click="toOtherPages('goodsCategoryEdit', 'normal', 'add')"
            v-if="parArray.indexOf('goodsadd_xzsp') != -1">新增商品</el-button>
          <el-button type="primary" plain @click="toOtherPages('goodsCategoryEdit', 'combination', 'add')"
            v-if="parArray.indexOf('goodsadd_xzsp') != -1">新增组合商品</el-button>
        </div>
      </div>
      <div style="padding: 0 10px;background-color: #fff;margin: 0 -10px;" v-loading="loading">
        <lb-table v-horizontal-scroll='"always"' border :column="columns" align="center" :data="list" pagination
          :total="page.totalNum" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50, 200]"
          :current-page.sync="page.currentPage" :page-size="page.pageSize" @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange" @refresh="fetchData" :orderStatistics="page.totalNum"
          statisticText="当前列表统计总商品数" @selection-change="handleSelectionChange">
        </lb-table>
      </div>
      <!--      <base-list :baseColumns="columns" :baseList="list" :searchObj="search" v-on:onMultipleSelection="onMultipleSelection" ref="baseList"></base-list>-->
    </div>
    <!--========================== el-dialog =================================-->
    <el-dialog :title="dialog.title" :visible.sync="dialog.visible" :width="dialog.width" :append-to-body="true"
      :custom-class="dialog.type === 'modifyState' ? 'modify-state' : ''">
      <template v-if="dialog.type === 'skuList'">
        <el-table :data="dialog.list" style="width: 100%">
          <el-table-column prop="sku" label="SKU编码" width="150">
          </el-table-column>
          <el-table-column prop="name" label="商品规格">
            <template slot-scope="scope">
              <span v-if="scope.row.secondGoodsSpecItemContent">{{ scope.row.firstGoodsSpecItemContent }} +
                {{ scope.row.secondGoodsSpecItemContent }}</span>
              <span v-else-if="scope.row.thirdGoodsSpecItemContent">{{ scope.row.firstGoodsSpecItemContent }} +
                {{ scope.row.secondGoodsSpecItemContent }} +
                {{ scope.row.thirdGoodsSpecItemContent }}</span>
              <span v-else>{{ scope.row.firstGoodsSpecItemContent }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="marketPrice" label="市场价"> </el-table-column>
          <el-table-column prop="retailPrice" label="零售价"> </el-table-column>
          <el-table-column prop="stock" label="库存"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="onCopySku(scope.row.sku)">复制</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <template v-if="dialog.type === 'modifyState'">
        <modify-state :dialogInfo="dialog" :list="giftListByGoodId"></modify-state>
        <div slot="title" class="header-title">
          <span class="icon"><i class="el-icon-warning"></i></span>
          <label class="name">{{ dialog.title }}</label>
        </div>
        <div slot="footer" class="footer">
          <el-button @click="centerModifyState">取 消</el-button>
          <el-button type="primary" @click="submitModifyState">确 定</el-button>
        </div>
      </template>
      <template v-if="dialog.type === 'retailPrice' ||
        dialog.type === 'store' ||
        dialog.type === 'sellNum' ||
        dialog.type === 'settlePrice'
      ">
        <div style="display: flex">
          <div>
            <el-button plain :type="isStatus == '1' ? 'primary' : ' '" @click="isUpPlatform(1)">已上架平台</el-button>
            <el-button plain :type="isStatus == '0' ? 'primary' : ' '" @click="isUpPlatform(0)">待上架平台</el-button>
          </div>
          <div class="dialog-search">
            <el-form :inline="true" :model="searchForm" ref="searchForm" class="search-form" size="small">
              <el-form-item label="平台名称" prop="name">
                <el-input v-model="platformName" placeholder="请输入平台名称" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="dialog-button">
            <el-button type="primary" size="small" @click="goodsPlatformPrice()">查询</el-button>
          </div>
        </div>
        <el-table border :data="dialog.list" :span-method="objectSpanMethod" style="width: 100%"
          :header-cell-style="{ 'text-align': 'center', background: '#F8F8F8' }"
          :cell-style="{ 'text-align': 'center' }">
          <el-table-column prop="name" label="平台名称" width="150">
          </el-table-column>
          <el-table-column prop="skuName" label="商品规格"> </el-table-column>
          <el-table-column prop="settlementPrice" label="结算价" v-if="dialog.type === 'settlePrice'">
          </el-table-column>
          <el-table-column prop="retailPrice" label="零售价" v-if="dialog.type === 'retailPrice'">
          </el-table-column>
          <el-table-column prop="store" label="可用库存" v-if="dialog.type === 'store'">
          </el-table-column>
          <el-table-column prop="sellNum" label="销量" v-if="dialog.type === 'sellNum'">
          </el-table-column>
        </el-table>
        <div class="dialog-pagination">
          <el-pagination @size-change="handleSizeChangeDialog" @current-change="handleCurrentChangeDialog"
            :current-page="1" :page-sizes="[10, 20, 30, 40]" :page-size="10"
            layout="total, sizes, prev, pager, next, jumper" :total="dialog.totalNum">
          </el-pagination>
        </div>
      </template>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="isShow" width="640px" :append-to-body="true">
      <template>
        <div v-if="title === '批量上架'">选择上架平台</div>
        <div v-else>选择下架平台</div>
        <div class="platform">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
            @change="handleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="dialog.platformId" @change="handleCheckedplatformChange">
            <el-checkbox style="width: 44%" v-for="item in platformList1" :label="item.platformId"
              :key="item.platformId">{{ item.platformName }}</el-checkbox>
          </el-checkbox-group>

          <!-- <el-radio-group v-model="dialog.platformId">
            <el-radio
              style="width: 40%"
              :label="item.id"
              v-for="(item, index) in platformList"
              :key="index"
              >{{ item.name }}</el-radio
            >
          </el-radio-group> -->
        </div>
        <div style="text-align: center">
          <el-button type="info" @click="isShow = false">取消</el-button>
          <el-button type="primary" @click="submitisUp()">确定</el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog title="商品上架平台" :visible.sync="isPlatform" width="592px" :append-to-body="true">
      <template>
        <div style="display: flex; flex-wrap: wrap">
          <div v-for="(item, index) in goodsPlatformList" :key="index" style="
              margin-right: 20px;
              width: auto;
              height: 32px;
              background: #f0f3fd;
              opacity: 1;
              border-radius: 4px;
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 400;
              line-height: 32px;
              color: #333333;
              text-align: center;
              padding-left: 8px;
              padding-right: 8px;
            ">
            {{ item.platformName }}
          </div>
        </div>
        <div style="
            width: 592px;
            height: 0px;
            border: 1px solid #d9d9d9;
            opacity: 1;
            margin-top: 30px;
            margin-left: -20px;
          "></div>
        <div style="text-align: center; margin-top: 14px">
          <!-- <el-button type="info" @click="isPlatform = false">取消</el-button> -->
          <el-button style="
              width: 120px;
              height: 36px;
              background: #4168e7;
              opacity: 1;
              border-radius: 4px;
            " type="primary" @click="isPlatform = false">确定</el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog :title="singleTitle" :visible.sync="isSingle" width="640px" :append-to-body="true">
      <template>
        <div style="display: flex">
          <div class="dialog-search">
            <el-form :inline="true" :model="searchForm" ref="searchForm" class="search-form" size="small">
              <el-form-item label="平台名称" prop="name">
                <el-input v-model="platformName" placeholder="请输入平台名称" clearable></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="dialog-button">
            <el-button type="primary" size="small" @click="searchPlatform()">查询</el-button>
          </div>
        </div>
        <el-table border :data="goodsPlatformList" style="width: 100%" :header-cell-style="{ color: '#333333' }">
          <el-table-column prop="platformName" label="平台名称">
            <template slot-scope="scope">
              <div>
                {{ scope.row.platformName
                }}<span v-if="scope.row.originFlag == true">(来源平台)</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="上下架" width="150">
            <template slot="header">
              <span>上下架</span>
              <el-tooltip effect="dark" content="控制该商品全部SKU规格在平台的上下架" placement="top">
                <i class="el-icon-question" style="
                    font-size: 20px;
                    cursor: pointer;
                    margin-left: 6px;
                    margin-top: 4px;
                  "></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-switch :value="scope.row.statusLabel" active-color="#409EFF" inactive-color="#909099"
                @change="controlUp(scope.row, scope.$index)">
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center; margin-top: 20px">
          <!-- <el-button type="info" @click="isPlatform = false">取消</el-button> -->
          <el-button type="primary" @click="submitSingle">确定</el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog title="提示信息" :visible.sync="isS" width="643px" :append-to-body="true">
      <template>
        <div class="info" style="text-align: left;margin-left: 60px;">
          <i class="el-icon-warning" style="color: red; font-size: 20px"></i>
          <span>{{ msg }}</span>
        </div>
        <div v-if="gL.length != 0" style="
              width:468px;
              background: #F1F6FF;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                line-height: 22px;
                color: #333333;
                margin-left: 60px;
                margin-top:15px;
                padding:12px 10px
              ">
          该商品已被<span v-if="gL.length != 0" style="color:#2d7edf">【</span>
          <span v-for="(item, index) in gL" :key="index" style="color:  #4168E7"><span v-if="index > 0"
              style="color:  #4168E7">，&nbsp;</span>{{ item }}</span>
          <span v-if="gL.length != 0" style="color:#2d7edf">】</span>关联，若确认下架，则所关联的商品都下架！
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isS = false">取消</div>
          <div class="info-s" @click="isSsubmit()">确定</div>
        </div>
      </template>
    </el-dialog>
    <el-dialog title="批量上架失败" :visible.sync="isE" width="640px" :append-to-body="true">
      <template>
        <el-table border :data="tableData2" style="width: 100%" :header-cell-style="{ color: '#333333' }">
          <el-table-column prop="index" label="" width="60">
            <template slot-scope="scope">
              <div>
                {{ scope.$index + 1
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="platformName" label="上架平台" width="150">

          </el-table-column>
          <el-table-column prop="goodsName" label="上架商品" width="150">

          </el-table-column>
          <el-table-column prop="message" label="失败原因">

          </el-table-column>
        </el-table>
        <div style="margin-top:10px;text-align: right;">
          <el-pagination @size-change="sizeChange2" @current-change="currentChange2" :current-page="page2"
            :page-size="size2" :page-sizes="pageSizes2" layout="total, sizes, prev, pager, next, jumper"
            :total="total2">
          </el-pagination>
        </div>

        <div style="text-align: center; margin-top: 20px">
          <!-- <el-button type="info" @click="isPlatform = false">取消</el-button> -->
          <el-button type="primary" @click="isE = false">确定</el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog title="批量下架确认" :visible.sync="isQ" width="640px" :append-to-body="true">
      <template>
        <el-table border :data="tableData3" style="width: 100%" :header-cell-style="{ color: '#333333' }">
          <el-table-column prop="index" label="" width="60">
            <template slot-scope="scope">
              <div>
                {{ scope.$index + 1
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="platformName" label="下架平台" width="150">

          </el-table-column>
          <el-table-column prop="goodsName" label="下架商品" width="150">

          </el-table-column>
          <el-table-column prop="message" label="原因">

          </el-table-column>
        </el-table>
        <div style="margin-top:10px;text-align: right;">
          <el-pagination @size-change="sizeChange3" @current-change="currentChange3" :current-page="page3"
            :page-size="size3" :page-sizes="pageSizes3" layout="total, sizes, prev, pager, next, jumper"
            :total="total3">
          </el-pagination>
        </div>

        <div style="text-align: center; margin-top: 20px">
          <el-button type="info" @click="isQ = false">取消</el-button>
          <el-button type="primary" @click="QS">确认下架</el-button>
        </div>
      </template>
    </el-dialog>
    <!-- 外部商品对外设置弹窗 -->
    <el-dialog center title="提示" :visible.sync="externalDialog.visible" width="400px" :append-to-body="true">
      <template>
        <div style="margin-left: 40px;">
          <div style="margin-bottom: 10px; font-size: 16px;">请选择所选商品是否对外</div>
          <el-select style="width:260px;" v-model="externalDialog.value" placeholder="请选择">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="2"></el-option>
          </el-select>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirmExternalSetting()">确认</el-button>
          <el-button type="info" @click="externalDialog.visible = false">取消</el-button>
        </div>
      </template>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="isImport" width="640px" :append-to-body="true">
      <template>
        <div class="popIn">
          <el-upload ref="tops" class="upload-demo" accept=".doc,.docx,.xls,.xlsx,.csv" drag action="#" :multiple="false"
            :http-request="fileImport" :limit="1">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </div>
        <div class="dialog-footer">
          <div @click="downloadTemplate">
            <el-button type="text" icon="el-icon-download">导入模板下载</el-button>
          </div>
          <div>
            <el-button class="cancel" @click="isImport = false">取消
            </el-button>
            <el-button class="affirm" type="primary" @click="submitImport">确定
            </el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, reactive } from '@vue/composition-api'
// import { getClientWidth } from "../../../utils/index.js";
import LbTable from '@/pages/purchase/components/lb-table/lb-table'
import BaseList from './components/BaseList.vue'
import breadcrumbTop from '../../components/breadcrumb.vue'
import Label from '@/pages/examination/label.vue'
import ModifyState from './components/ModifyState.vue'
import mixinsGiftlist from './mixins/mixinsGiftlist.js'
import JSZip, { external } from 'jszip';
import { saveAs } from 'file-saver';
import axios from 'axios'
export default {
  mixins: [mixinsGiftlist],
  components: {
    Label,
    LbTable,
    breadcrumbTop,
    ModifyState
    // BaseList
  },
  data() {

    return {
      page3: 1, //第几页
      size3: 10, //一页多少条
      total3: 0, //总条目数
      pageSizes3: [3, 5, 10, 20,], //可选择的一页多少条
      tableData3: [], //表格绑定的数据
      isQ: false,
      page2: 1, //第几页
      size2: 10, //一页多少条
      total2: 0, //总条目数
      pageSizes2: [3, 5, 10, 20,], //可选择的一页多少条
      tableData2: [], //表格绑定的数据
      isE: false,
      eList: [],
      msg: '',
      gL: [],
      isS: false,
      cSkuList: [],
      singleTitle: '上/下架',
      isSingle: false,
      isImport: false,
      file: '',
      isIndeterminate: true,
      checkAll: false,
      isStatus: 1,
      platformName: '',
      isPlatform: false,
      isUp: 'up',
      shopLists: [
        {
          skuNo: '1',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '1',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '1',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '2',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '2',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '3',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '4',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '4',
          name: 'cdd',
          retailPrice: 36
        },
      ],
      title: '批量上架',
      isShow: false,
      GoodsExportLoading: false,
      // dataList: {
      //   list: [
      //     { title: '商品管理', path: '', type: '0' },
      //     { title: '商品列表', path: '', type: '1' }
      //   ]
      // },
      searchForm: {
        name: '', // 	否 	string 	商品名称
        goodsNo: '', // 	否 	string 	商品编号
        categoryId: '', // 	否 	int 	类目id（数据来源：接口 - /order/comm/commodityCategory/commList）
        brandId: '', // 	否 	int 	品牌id（数据来源：接口 - /order/comm/brand/list?pageNo=1&pageSize=999）
        goodsTypes: [], // 	否 	int 	类型（1：普通商品；2：虚拟商品；3：赠品；字典：goods_type）
        status: '', // 	否 	int 	状态（字典：sale_status）
        platformId: '',//来源
        orderBy: '', // 	否 	int 	排序（0价格；1可用库存；2总销量）
        orderByType: '', // 	否 	int 	排序方式（0正序；1倒序）
        pageNo: 1, // 保留用于API调用
        pageSize: 10, // 保留用于API调用
        outGoodsNo: '',
        foreignGoods: null, //1是对外商品，2不是
        // searchKeyword: '', // 搜索关键字
        // searchType: 'returnOrderNo' // 搜索类型
      },
      combinedSearchItems: [
        {
          label: '商品名称',
          value: 'name',
          keyword: '',
          options: [
            { label: '商品名称', value: 'name' },
            { label: '商品规格', value: 'goodsSpec' },
            { label: '分仓', value: 'warehouseType' },
          ]
        },
        {
          label: '商品编码',
          value: 'goodsNo',
          keyword: '',
          options: [
            { label: '商品编码', value: 'goodsNo' },
            { label: '商品外部编码', value: 'outGoodsNo' },
            { label: '组合商品编码', value: 'combinationCode' },
            { label: '商品规格编码', value: 'specCode' },
          ]
        },
        {
          label: '状态',
          value: 'status',
          keyword: '',
          options: [
            { label: '状态', value: 'status' },
            { label: '对外商品', value: 'foreignGoods' },
          ]
        },
      ],
      currentStatus: 100, // 当前列表状态
      groupByStatus: { // 数据切换
        total: 100, // 全部
        up: 200, // 上架中商品
        down: 300 // 已下架商品
      },
      countGroupByStatus: { // 商品列表数量统计
        // totalCount: 100, // 总数
        // onSaleCount: 200, // 上架数量
        // offSaleCount: 300 // 下架数量
        total: 0,
        down: 0,
        up: 0,
        wait: 0
      },
      // 数据列表
      list: [],
      loading: false,
      categoryList: [], // 目类列表
      brandList: [], // 品牌
      originList: [

      ],//来源列表
      // 设置对外
      externalDialog: {
        visible: false,
        value: null // 2不对外，1对外
      },
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        { label: '商品编号', prop: 'goodsNo', fixed: 'left', minWidth: '120' },
        {
          label: '商品名称',
          minWidth: '220',
          render: (h, scope) => {
            return (
              <div style="display:flex;align-items:center">
                <el-image src={scope.row.mainImageArr[0]} preview-src-list={scope.row.mainImageArr} lazy></el-image>
                <span style="padding-left:10px">{scope.row.name || '--'}</span>
              </div>
            )
          }
        },
        {
          label: '组合商品编号', prop: 'combinationCode', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <span>{scope.row.combinationCode || '--'}</span>
              </div>
            )
          }
        },
        {
          label: '商品外部编号', prop: 'outGoodsNo', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <span>{scope.row.outGoodsNo || '--'}</span>
              </div>
            )
          }
        },
        { label: '拣货单位', prop: 'pickingUnit', minWidth: '120' },
        {
          label: '重量', prop: 'weight', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <span>{scope.row.weight || '--'}</span>
              </div>
            )
          }
        },
        {
          label: '体积', prop: 'volume', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <span>{scope.row.volume || '--'}</span>
              </div>
            )
          }
        },
        { label: '商品类目', prop: 'categoryName', minWidth: '200' },
        { label: '分仓', prop: 'warehouseTypeName', minWidth: '200' },
        { label: '虚拟库存数', prop: 'virtualStock', minWidth: '200' },
        {
          label: '可用库存',
          minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <span>{scope.row.stock}</span>
                <i class="el-icon-caret-bottom" style="font-size:20px;cursor:pointer" onClick={() => { this.getretailPrice('store', scope.row) }}></i>
              </div>
            )
          }
        },
        { label: '品牌', prop: 'brandName', minWidth: '120' },
        {
          label: '上架平台',
          minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <span style="cursor:pointer" onClick={() => { this.platformView(scope.row) }}>{scope.row.platformNum}</span>
              </div>
            )
          }
        },
        {
          label: '对外商品', prop: 'foreignGoods', minWidth: '200',
          render: (h, scope) => {
            return (
              <div> {scope.row.foreignGoods === 1 ? '是' : '否'} </div>
            )
          }
        },
        { label: '商品类型', prop: 'goodsType', minWidth: '120' },

        // { label: '价格', prop: 'marketPrice', minWidth: '120', sortable: true },
        {
          label: '结算价', prop: 'settlePrice', minWidth: '200',
          render: (h, scope) => {
            return (
              <div>
                <span>{scope.row.settlePrice}</span>
                <i class="el-icon-caret-bottom" style="font-size:20px;cursor:pointer" onClick={() => { this.getretailPrice('settlePrice', scope.row) }}></i>
              </div>
            )
          }
        },
        {
          label: '零售价',
          minWidth: '200',
          render: (h, scope) => {
            return (
              <div>
                <span>{scope.row.retailPrice}</span>
                <i class="el-icon-caret-bottom" style="font-size:20px;cursor:pointer" onClick={() => { this.getretailPrice('retailPrice', scope.row) }}></i>
              </div>
            )
          }
        },
        {
          label: '内购价',
          minWidth: '200',
          render: (h, scope) => {
            return (
              <div>
                <span>{scope.row.purchasePrice}</span>
              </div>
            )
          }
        },
        {
          label: '供应商',
          minWidth: '200',
          render: (h, scope) => {
            return (
              <div>
                <span>{scope.row.supplierName}</span>
              </div>
            )
          }
        },
        {
          label: '销量',
          prop: 'soldNum',
          minWidth: '120',
          renderHeader: (h, scope) => {
            return (
              <div>
                <span>销量</span>
                <el-tooltip effect="dark" content="不包含虚拟销量" placement="top">
                  <i class="el-icon-question" style="font-size:20px;cursor:pointer;margin-left:6px;margin-top:4px"></i>
                </el-tooltip>
              </div>
            )
          },
          render: (h, scope) => {
            return (
              <div>
                <span>{scope.row.soldNum || 0}</span>
                <i class="el-icon-caret-bottom" style="font-size:20px;cursor:pointer" onClick={() => { this.getretailPrice('sellNum', scope.row) }}></i>
              </div>
            )
          }
        },
        {
          label: '状态',
          minWidth: '100',
          render: (h, scope) => {
            return (
              <div>
                <p class={scope.row.status === 1 ? 'success' : 'danger'}>{scope.row.statusLabel}</p>
              </div>
            )
          }
        },
        { label: '创建时间', prop: 'createdTime', minWidth: '200' },
        { label: '修改时间', prop: 'updatedTime', minWidth: '200', sortable: true },
        { label: '最新修改人', prop: 'updateByName', minWidth: '120' },
        { label: '商品来源', prop: 'origin', minWidth: '120' },
        {
          label: '负库存下单',
          width: '80',
          fixed: 'right',
          renderHeader: (h) => {
            return (
              <div>
                <span>负库存下单</span>
              </div>
            )
          },
          render: (h, scope) => {
            // 组合商品不显示该开关
            if (scope.row.combinationCode) {
              return (<span>--</span>)
            }
            const enabled = this.getNegativeStockEnabled(scope.row)
            return (
              <el-switch
                value={enabled}
                active-color="#409EFF"
                inactive-color="#909099"
                onChange={(val) => { this.onToggleNegativeStock(scope.row, val) }}
              ></el-switch>
            )
          }
        },
        {
          label: '操作',
          minWidth: '150',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <el-link size='mini' type='primary' onClick={() => { const routeName = scope.row.combinationCode ? 'goodsCombinationEdit' : 'goodsEdit'; this.toOtherPages(routeName, scope.row.id, 'edit') }} class={this.parArray.indexOf('goods_eidt_ckbj') != -1 ? 'info' : 'hide-content'}>查看/编辑</el-link>
                <el-dropdown onCommand={(command) => this.handleMoreCommand(command, scope.row, scope.$index)} trigger='hover'>
                  <el-button size='mini' type='primary' plain style="cursor:pointer;margin-left:10px;">更多
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="UpDown" style={this.parArray.indexOf('putOnCode') != -1 ? '' : 'display:none;'}>{scope.row.status === 1 ? '下架' : '上架'}</el-dropdown-item>
                    <el-dropdown-item command="copySku">复制SKU编码</el-dropdown-item>
                    <el-dropdown-item command="exportImage">导出图片</el-dropdown-item>
                    <el-dropdown-item command="delete" style="color: #f56c6c;" class={this.parArray.indexOf('delete_goods_sc') != -1 ? '' : 'hide-content'}>删除</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                {/* <el-link size='mini' type='primary' onClick={() => { this.singleOpetion(scope.row.status === 1 ? 'down' : 'up', scope.row) }} class={this.parArray.indexOf('putOnCode') != -1 ? 'info' : 'hide-content'}>{scope.row.status === 1 ? '上/下架' : '上/下架'}</el-link>
                <el-link size='mini' type='primary' onClick={() => { this.getGoodCopySku('skuList', scope.row) }}>复制SKU编码</el-link>
                <el-link size='mini' type='primary' onClick={() => { this.importImage(scope.row, scope.$index) }}>导出图片</el-link>
                <el-link size='mini' type='danger' onClick={() => { this.onGoodsDelete(scope.row, scope.$index) }} class={this.parArray.indexOf('delete_goods_sc') != -1 ? 'info' : 'hide-content'}>删除</el-link> */}
              </div>
            )
          }
        }],
      page: { currentPage: 1, pageSize: 10, totalNum: 0, status: '' },
      dialog: { visible: false, title: '编辑', type: '', row: {}, list: [], batch: false, titleArr: [], totalNum: 0, page: 1, pageNo: 10, shopId: null, platformId: [], platformIds: [] },
      dictionaries: { // 字典数据
        sale_status: [], // 状态
        goods_type: [] // 商品类型
      },
      selectionGoods: [], // 选 中 商品
      parArray: [], // 按钮权限
      platformList: [],//来源列表
      platformList1: [],//来源列表
      goodsPlatformList: [],//商品对应平台列表
      selectionId: [],//选中商品
      singleId: null,
      cIds: [],
      gIndex: null,
      rows: {}
    }
  },
  mounted() {

  },
  beforeRouteEnter(to, from, next) {
    if (from.name == 'goodsEdit') {
      next(vm => {
        vm.fetchData();
      });
    } else {
      next(vm => {
        vm.fetchData();
      });
    }
  },
  created() {
    this.fetchData()
    this.getCategoryList() // 获取 目类 列表
    this.getBrandList() // 获取 品牌 列表
    this.goodsPlatforms()//获取商品来源
    // this.goodsPlatformPrice()//获取商品对应零售价，结算价，库存
    // 权限设定判断
    this.limits = JSON.parse(sessionStorage.getItem('limit'))
    const params = this.limits.buttonTreeDto.filter(
      (item) => item.menuCode === 'goodsList'
    )
    params[0].buttonList.forEach((item) => {
      this.parArray.push(item.code)
    })
    //获取字典值
    for (const type in this.dictionaries) { this.getDictionaries(type) }
  },
  /*
  watch: {
    screenWidth(val) {
      this.screenWidth = val;
      console.log("this.screenWidth",this.screenWidth)
      this.windowOnresize()
    }
  },
  */
  methods: {
    handleMoreCommand(command, row, index) {
      switch (command) {
        case 'UpDown':
          this.singleOpetion(row.status === 1 ? 'down' : 'up', row);
          break;
        case 'copySku':
          this.getGoodCopySku('skuList', row);
          break;
        case 'exportImage':
          this.importImage('row', index);
          break;
        case 'delete':
          this.onGoodsDelete(row, index);
          break;
        default:
          break;
      }
    },
    fileImport(fileObj) {
      this.file = fileObj.file
    },
    onImport() {
      this.isImport = true
      this.file = ''
      this.$nextTick(() => {
        if (this.$refs['tops']) {
          this.$refs['tops'].clearFiles()
        }
      })
    },
    downloadlink(url) {
      let a = document.createElement('a')
      a.href = url
      a.click()
    },
    downloadTemplate() {
      this.$api.goodsImportTemplate().then(res => {
        if (res.code === 0) {
          this.downloadlink(res.data)
          this.$message.success('模板下载成功')
        } else {
          this.$message.error(res.message || '模板下载失败')
        }
      })
    },
    submitImport() {
      if (this.file == '') {
        this.$message.error('请选择文件')
        return
      }
      const formData = new FormData()
      formData.append('file', this.file)
      console.log('formData', formData);
      console.log('this.file:', this.file);
console.log('file size:', this.file.size);
console.log('file name:', this.file.name);
      this.$api.goodsImportModified(formData).then(res => {
        if (res.code === 0) {
          this.$message.success('操作成功')
          if (res.data) {
            this.downloadlink(res.data)
          }
          this.isImport = false
          this.fetchData('search')
        } else {
          this.$message.error(res.message || '导入失败')
        }
      })
    },
    // 处理表格选择变化
    handleSelectionChange(selection) {
      this.selectionGoods = selection;
    },
    // 处理类型变化
    handleSearchTypeChange(item, index) {
      item.keyword = '';
    },
    // 批量对外设置按钮点击事件
    handleBatchExternalSetting() {
      if (this.selectionGoods.length === 0) {
        this.$message({ type: 'warning', message: '请选择要设置的商品' });
        return;
      }
      //重置选择
      this.externalDialog.value = null;
      this.externalDialog.visible = true;
    },
    // 确认批量对外设置
    confirmExternalSetting() {
      if (this.externalDialog.value === null) {
        this.$message({ type: 'warning', message: '请选择是否对外' });
        return;
      }
      // 获取选中的商品id
      const selectedIds = this.selectionGoods.map(item => item.id);

      // 调用批量设置对外的api
      this.batchSetExternalStatus(selectedIds, this.externalDialog.value);
    },
    // 批量设置对外状态
    batchSetExternalStatus(goodsIds, isExternal) {
      this.$api.goodsBatchForeign(goodsIds, {
        type: isExternal
      }).then(res => {
        if (res.code === 0) {
          this.$message({
            type: 'success',
            message: `批量设置${isExternal == '1' ? '对外' : '不对外'}成功`
          });
          this.externalDialog.visible = false;
          // 刷新数据
          this.fetchData();
        } else {
          this.$message({
            type: 'error',
            message: res.msg || '设置失败'
          });
        }
      }).catch(err => {
        console.error(err);
        this.$message({
          type: 'error',
          message: '设置失败'
        });
      });
    },
    // 图片压缩前转换
    imgToBuffer(url) {
      return new Promise((resolve, reject) => {
        const xml = new XMLHttpRequest();
        xml.open('GET', url, true);
        xml.responseType = 'blob';
        xml.onload = function ({ currentTarget }) { //从事件对象结构出currentTarget
          const { status, response } = currentTarget;
          status === 200 ? resolve(response) : reject(status); // response就是转化后的
        };
        xml.send();
      });
    },
    getFile(url) {
      return new Promise((resolve, reject) => {
        this.axios({
          method: 'get',
          url,
          responseType: 'arraybuffer'
        }).then(data => {
          resolve(data.data)
        }).catch(error => {
          reject(error.toString())
        })
      })

    },
    sanitizedFileName(fileName) {
      // 使用正则表达式匹配并替换特殊字符
      return fileName.replace(/[\\\/:*?"<>]/g, '_');
    },
    importImage(row, index) {
      this.axios.get('/goods/goods/getAllImages?goodsId=' + row.id).then(async res => {
        if (res.code == 0) {
          const zip = new JSZip();
          const list = [
            ...(res.data.mainImageList || []),
            ...(res.data.detailImageList || []),
            ...(res.data.skuImageList || [])
          ].map(item => ({
            name: this.sanitizedFileName(item.fileName),
            url: item.url
          }));

          try {
            // 使用 Promise.all 等待所有图片下载完成
            await Promise.all(list.map(async item => {
              const response = await fetch(item.url);
              const contentType = response.headers.get('content-type');
              const extension = contentType ? contentType.split('/')[1] : 'jpg';  // 默认jpg
              const blob = await response.blob();
              zip.file(`${item.name}.${extension}`, blob);
            }));

            // 所有图片都处理完后，生成并下载 zip
            const blob = await zip.generateAsync({ type: "blob" });
            saveAs(blob, `${row.goodsNo}+${row.name}`);
          } catch (error) {
            console.error('下载图片出错:', error);
            // 这里可以添加错误提示
          }
        }
      })
    },
    //获取表格数据，自行分页（splice）
    getTabelData2() {
      let data = JSON.parse(JSON.stringify(this.eList))
      this.tableData2 = data.splice(
        (this.page2 - 1) * this.size2,
        this.size2
      );
      this.total2 = this.eList.length
    },
    //page改变时的回调函数，参数为当前页码
    currentChange2(val) {
      console.log("翻页，当前为第几页", val);
      this.page2 = val;
      this.getTabelData2();
    },
    //size改变时回调的函数，参数为当前的size
    sizeChange2(val) {
      console.log("改变每页多少条，当前一页多少条数据", val);
      this.size2 = val;
      this.page2 = 1;
      this.getTabelData2();
    },
    //获取表格数据，自行分页（splice）
    getTabelData3() {
      let data = JSON.parse(JSON.stringify(this.eList))
      this.tableData3 = data.splice(
        (this.page3 - 1) * this.size3,
        this.size3
      );
      this.total3 = this.eList.length
    },
    //page改变时的回调函数，参数为当前页码
    currentChange3(val) {
      console.log("翻页，当前为第几页", val);
      this.page3 = val;
      this.getTabelData3();
    },
    //size改变时回调的函数，参数为当前的size
    sizeChange3(val) {
      console.log("改变每页多少条，当前一页多少条数据", val);
      this.size3 = val;
      this.page3 = 1;
      this.getTabelData3();
    },
    isSsubmit() {
      this.isS = false
      if (this.goodsPlatformList[0].statusLabel == false) {
        this.goodsPlatformList[this.gIndex].statusLabel = false
      } else {
        this.goodsPlatformList[this.gIndex].statusLabel = !this.goodsPlatformList[this.gIndex].statusLabel
      }

      if (this.rows.originFlag && this.rows.statusLabel == true) {
        if (rows.platformId == 0) {
          for (let i = 0; i < this.goodsPlatformList.length; i++) {
            if (i <= 0) {
              this.goodsPlatformList[i].statusLabel = true
            } else {
              this.goodsPlatformList[i].statusLabel = false
            }
          }
        } else {
          for (let i = 0; i < this.goodsPlatformList.length; i++) {
            if (i <= 1) {
              this.goodsPlatformList[i].statusLabel = true
            } else {
              this.goodsPlatformList[i].statusLabel = false
            }
          }
        }
      } else if (this.rows.originFlag && this.rows.statusLabel == false) {
        this.goodsPlatformList.forEach(item => {
          Object.assign(item, { statusLabel: false })
        })
      }
    },
    msgInfo(row, msg, index) {
      this.$confirm(msg, '提示信息', {
        title: '提示信息',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.goodsPlatformList[index].statusLabel = !this.goodsPlatformList[index].statusLabel
        if (row.originFlag && row.statusLabel == true) {
          if (row.platformId == 0) {
            for (let i = 0; i < this.goodsPlatformList.length; i++) {
              if (i <= 0) {
                this.goodsPlatformList[i].statusLabel = true
              } else {
                this.goodsPlatformList[i].statusLabel = false
              }
            }
          } else {
            for (let i = 0; i < this.goodsPlatformList.length; i++) {
              if (i <= 1) {
                this.goodsPlatformList[i].statusLabel = true
              } else {
                this.goodsPlatformList[i].statusLabel = false
              }
            }
          }
        } else if (row.originFlag && row.statusLabel == false) {
          this.goodsPlatformList.forEach(item => {
            Object.assign(item, { statusLabel: false })
          })
        }
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消'
        // })
      })
    },
    controlUp(row, index) {
      console.log(row)
      let data = {

      }
      let msg = ''
      if (row.originFlag && row.statusLabel == true) {
        data = {
          goodsId: this.singleId,
          platformId: row.platformId,
          isMain: 1,
          status: 0
        }
        this.$api.goodIsPutOffCheck(data).then(res => {
          if (res.code == 0) {
            console.log(res.data)
            let str = ''
            if (res.data.goodsNameList) {
              //   res.data.goodsNameList.forEach(item => {
              //   if (str != '') {
              //     str = str + '、' + item
              //   } else {
              //     str = item
              //   }

              //   // msg = '是否确认下架'+ row.platformName+'的平台？该平台下架后，该商品上架的所有平台都下架！该商品已被' + str + '关联，若确认下架，则所关联的商品都下架！'
              //   // this.msgInfo(row,msg, index)
              // })
              this.isS = true
              this.msg = '是否确认下架' + row.platformName + '的平台？该平台下架后，该商品上架的所有平台都下架!'
              this.gIndex = index
              this.gL = res.data.goodsNameList
              this.rows = row
            } else {
              this.isS = true
              this.gIndex = index
              // msg = '是否确认下架'+ row.platformName+'的平台？该平台下架后，该商品上架的所有平台都下架!'
              // this.msgInfo(row,msg, index)
              this.msg = '是否确认下架' + row.platformName + '的平台？该平台下架后，该商品上架的所有平台都下架!'
              this.rows = row
            }



          }
        })
      } else if (row.originFlag && row.statusLabel == false && row.platformId == 0) {
        this.goodsPlatformList[index].statusLabel = true
      } else if (!row.originFlag && row.statusLabel == true) {
        this.goodsPlatformList[index].statusLabel = false
      } else if (!row.originFlag && this.goodsPlatformList[0].statusLabel == false && row.statusLabel == false) {
        this.goodsPlatformList[index].statusLabel = false
        this.isS = true
        this.msg = '来源平台已下架，五域不能操作上架'
        this.gIndex = index
      } else if (row.statusLabel == false) {
        data = {
          goodsId: this.singleId,
          platformId: row.platformId,
          isMain: 0,
          status: 1
        }
        this.$api.goodIsPutOffCheck(data).then(res => {
          if (res.code == 0) {
            console.log(res.data)
            if (res.data.status == 1) {
              msg = `该商品已同步到该平台，待平台审核上架!`
            } else {
              msg = `该商品未设置【结算价】，请设置后再上架该商品！`
            }
            this.msgInfo(row, msg, index)
          }
        })
      }

      // if (index == 0) {
      //   msg = `是否确认下架【商品来源】的平台？该平台下架后，该商品上架的所有平台都下架！该商品已被【XXX商品名称】、【XXX商品名称】关联，若确认下架，则所关联的商品都下架！`
      // } else if (index == 1) {
      //   msg = `该商品未设置【结算价】，请设置后再上架该商品！`
      // } else {
      //   msg = `该商品已同步到该平台，待平台审核上架!`
      // }


      // return
      // if (row.originFlag && row.statusLabel == true) {
      //   if (row.platformId == 0) {
      //     for (let i = 0; i < this.goodsPlatformList.length; i++) {
      //       if (i <= 0) {
      //         this.goodsPlatformList[i].statusLabel = true
      //       } else {
      //         this.goodsPlatformList[i].statusLabel = false
      //       }
      //     }
      //   } else {
      //     for (let i = 0; i < this.goodsPlatformList.length; i++) {
      //       if (i <= 1) {
      //         this.goodsPlatformList[i].statusLabel = true
      //       } else {
      //         this.goodsPlatformList[i].statusLabel = false
      //       }
      //     }
      //   }
      // } else if (row.originFlag && row.statusLabel == false) {
      //   this.goodsPlatformList.forEach(item => {
      //     Object.assign(item, { statusLabel: false })
      //   })
      // }
    },
    searchPlatform() {
      this.searchGoodsPlatform()
    },
    searchGoodsPlatform() {
      this.goodsPlatformList = []
      this.$nextTick(() => {
        let data = {
          id: this.singleId,
          name: this.platformName
        }
        this.$api.goodsPlatformStatus1(data).then((res) => {
          let dataC = res.data
          // dataC.forEach(item => {
          //   if (item.originFlag == true && item.status == 0) {
          //     Object.assign(item, { status: 0 })
          //   }
          // })
          // // if (dataC[0].status == 0) {
          // //   dataC.forEach(item => {
          // //     Object.assign(item, { status: 0 })
          // //   })
          // // }

          dataC.forEach(item => {
            if (item.status == 1) {
              Object.assign(item, { statusLabel: true })

            } else {
              Object.assign(item, { statusLabel: false })
            }
          })
          this.goodsPlatformList = dataC
          console.log(this.goodsPlatformList)
          this.$forceUpdate()
        }).catch((err) => {
          console.log(err)
        })
      })

    },
    singleOpetion(type, row) {
      this.cSkuList = row.skuList
      if (type == 'down') {
        this.singleTitle = '上/下架'
        this.isSingle = true
      } else {
        this.singleTitle = '上/下架'
        this.isSingle = true
      }
      this.singleId = row.id
      this.searchGoodsPlatform()
    },
    getValue(object) {
      let isEmpty = false
      Object.keys(object).forEach(el => {
        if (object[el] !== null && object[el] !== '') {
          isEmpty = true
        }
      })
      if (isEmpty) { return true } else { return false }
    },

    submitSingle() {
      // console.log(this.cSkuList.every(item => this.getValue(item) == true))
      let isTrue = this.cSkuList.every(item => this.getValue(item) == true)
      if (isTrue) {
        this.dialog.platformIds = []
        this.goodsPlatformList.forEach(item => {
          if (item.statusLabel == true) {
            item.status = 1
          } else {
            item.status = 0
          }
          let obj = {
            id: item.platformId,
            status: item.status,
          }
          this.dialog.platformIds.push(obj)
        })
        this.selectionId = []
        this.selectionId.push(this.singleId)
        if (this.singleTitle == '上/下架') {
          this.goodsPlatformPutOff1(1)
        } else {
          this.goodsPlatformPutOff1(0)
        }
      } else {
        this.$message.warning('商品信息未完善')
      }
    },
    submitisUp() {
      if (this.title == '批量上架') {
        this.goodsPlatformPutOff(1)
      } else {
        this.goodsPlatformPutOff(0)
      }

    },
    //上下架
    goodsPlatformPutOff1(val) {
      let data = {
        ids: this.selectionId,
        platformIds: this.dialog.platformIds,
        // status: val,
        type: '0',
        repeat: '1',
        status: '0'
      }
      this.$api.goodsPlatformPutOffV2(data).then((res) => {
        if (res.code == 0) {
          this.$message({ type: 'success', message: '操作成功' })
          this.isShow = false
          this.isSingle = false
          this.fetchData('search')
        } else {
          this.isShow = false
          this.isSingle = false
        }

      }).catch((err) => {
        console.log(err)
      })
    },
    QS() {
      let data = {
        ids: this.selectionId,
        platformIds: this.dialog.platformIds,
        status: '0',
        type: '1',
        repeat: '1',
      }
      this.$api.goodsPlatformPutOffV2(data).then((res) => {
        if (res.code == 0) {

          this.isQ = false
          this.isShow = false
          this.isSingle = false
          this.$message({ type: 'success', message: '操作成功' })

        }

      }).catch((err) => {
        console.log(err)
      })
    },
    //批量上下架
    goodsPlatformPutOff(val) {
      if (val == 1) {
        let data = {
          ids: this.selectionId,
          platformIds: this.dialog.platformIds,
          status: '1',
          type: '1',
          repeat: '0',
        }
        this.$api.goodsPlatformPutOffV2(data).then((res) => {
          if (res.code == 0) {

            if (res.data.status == 0) {
              this.isShow = false
              this.isSingle = false
              this.$message({ type: 'success', message: '操作成功' })
            } else {
              this.isE = true
              this.eList = res.data.goodsList
              this.getTabelData2()
            }

          }

        }).catch((err) => {
          console.log(err)
        })
      } else {
        let data = {
          ids: this.selectionId,
          platformIds: this.dialog.platformIds,
          status: '0',
          type: '1',
          repeat: '0',
        }
        this.$api.goodsPlatformPutOffV2(data).then((res) => {
          if (res.code == 0) {

            if (res.data.status == 0) {
              this.$message({ type: 'success', message: '操作成功' })
              this.isShow = false
              this.isSingle = false
            } else {
              this.isQ = true
              this.eList = res.data.goodsList
              this.getTabelData3()
            }

          }

        }).catch((err) => {
          console.log(err)
        })
      }

    },
    handleCheckAllChange(val) {
      console.log(val)
      let arr = []
      this.platformList1.forEach(item => {
        arr.push(item.platformId)
      })
      this.dialog.platformId = val == true ? arr : [];
      this.dialog.platformIds = []
      if (this.title == '批量上架') {
        this.platformList1.forEach(item => {
          this.dialog.platformId.forEach(itm => {
            if (item.platformId == itm) {
              let obj = {
                id: item.platformId,
                status: 1
              }
              this.dialog.platformIds.push(obj)
            }
          })
        })
      } else {
        this.platformList1.forEach(item => {
          this.dialog.platformId.forEach(itm => {
            if (item.platformId == itm) {
              let obj = {
                id: item.platformId,
                status: 0
              }
              this.dialog.platformIds.push(obj)
            }
          })
        })
      }

      this.isIndeterminate = false;
    },
    handleCheckedplatformChange(value) {
      console.log(this.platformList1)
      console.log(value, this.dialog.platformId)
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.platformList1.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.platformList1.length;
      this.dialog.platformIds = []
      if (this.title == '批量上架') {
        this.platformList1.forEach(item => {
          this.dialog.platformId.forEach(itm => {
            if (item.platformId == itm) {
              let obj = {
                id: item.platformId,
                status: 1
              }
              this.dialog.platformIds.push(obj)
            }
          })
        })
      } else {
        this.platformList1.forEach(item => {
          this.dialog.platformId.forEach(itm => {
            if (item.platformId == itm) {
              let obj = {
                id: item.platformId,
                status: 0
              }
              this.dialog.platformIds.push(obj)
            }
          })
        })
      }
      console.log(this.dialog.platformIds)
    },
    isUpPlatform(val) {
      this.isStatus = val
      this.goodsPlatformPrice()
    },
    platformView(row) {
      this.isPlatform = true
      this.goodsPlatformList = []
      let data = {
        id: row.id
      }
      this.$api.goodsPlatformStatus1(data).then((res) => {
        // this.goodsPlatformList = res.data
        res.data.forEach(item => {
          if (item.status == 1) {
            this.goodsPlatformList.push(item)
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    changeUp(val) {
      this.isUp = val
    },
    goodsPlatformPrice() {
      let data = {
        id: this.dialog.shopId,
        status: this.isStatus,
        name: this.platformName,
        pageSize: this.dialog.pageNo,
        pageNo: this.dialog.page,
      }
      this.dialog.list = []
      this.$api.goodsPlatformPrice(data).then((res) => {
        // this.dialog.list = res.data.list
        let renderList = []
        res.data.list.forEach(item => {
          item.items.forEach(itm => {
            itm.name = item.name
            renderList.push(itm)
            this.dialog.list = renderList
          })
        })

        this.dialog.totalNum = res.data.totalNum
      }).catch((err) => {
        console.log(err)
      })
    },
    //表格合并行和列
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      let pos = 0
      let len = this.dialog.list.length
      for (let i = 0; i < len; i++) {
        const item = this.dialog.list[i]
        if (i === 0) {
          item.$rows = 1
          pos = 0
        }
        if (i !== 0) {
          if (item.name === this.dialog.list[i - 1].name) {
            item.$rows = 0
            this.dialog.list[pos].$rows = this.dialog.list[pos].$rows + 1
          } else {
            item.$rows = 1
            pos = i
          }
        }
      }
      if (columnIndex === 0) {
        return {
          rowspan: row.$rows,
          colspan: row.$rows ? 1 : 0,
        };
      }
    },
    getretailPrice(title, row) {
      this.dialog.visible = true
      if (title == 'retailPrice') {
        this.dialog.title = '零售价'
      } else if (title == 'store') {
        this.dialog.title = '可用库存'
      } else if (title == 'settlePrice') {
        this.dialog.title = '结算价'
      } else {
        this.dialog.title = '销量'
      }
      this.dialog.width = '640px'
      this.dialog.type = title
      this.dialog.shopId = row.id
      this.goodsPlatformPrice()
      // this.dialog.list = row.skuList
    },
    fetchData(type) {
      this.loading = true;
      if (type == 'reset') {
        this.$refs['searchForm'].resetFields()
        this.searchForm = {}
        this.page.currentPage = 1
        this.page.pageSize = 10
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      // 同步 page 和 searchForm 的分页字段
      this.searchForm.pageNo = this.page.currentPage
      this.searchForm.pageSize = this.page.pageSize
      let params = {
        pageNo: this.searchForm.pageNo,
        pageSize: this.searchForm.pageSize,
        status: this.searchForm.status
      }
      if (type == 'search') {
        this.page.currentPage = 1
        this.searchForm.pageNo = 1
      }
      const searchForm = this.searchForm
      params = Object.assign(params, searchForm)
      if (searchForm.categoryId) {
        params.categoryId = searchForm.categoryId[searchForm.categoryId.length - 1]
      }

      // 去除字符串 前后 空格
      for (const item in params) { if (typeof params[item] === 'string') { params[item] = params[item].trim() } }
      const upIndex = this.dictionaries.sale_status.findIndex(e => { return e.dictName.indexOf('上') > -1 })
      const downIndex = this.dictionaries.sale_status.findIndex(e => { return e.dictName.indexOf('下') > -1 })
      if (type === 'up' || this.currentStatus === this.groupByStatus.up) {
        params.status = Number(this.dictionaries.sale_status[upIndex].dictId)
        this.page.status = params.status
      }
      if (type === 'down' || this.currentStatus === this.groupByStatus.down) {
        params.status = Number(this.dictionaries.sale_status[downIndex].dictId)
        this.page.status = params.status
      }
      // 处理组合搜索项
      this.combinedSearchItems.forEach(item => {
        if (item.keyword && item.keyword.trim() && item.value) {
          params[item.value] = item.keyword.trim();
        }
      });
      console.log(params, 'searchForm')
      this.$api.goodsPageList(params).then((res) => {
        if (res.code === 0) {
          res.data.list.forEach(e => {
            // if (e.mainImage && e.mainImage.indexOf('http://fenxiao.muruji.com/') !== 0) { e.mainImage = this.ImgHttps + e.mainImage }
            /*
            if (e.mainImage && e.mainImage.indexOf('http://fenxiao.muruji.com/') !== 0) {
              e.mainImage = this.ImgHttps + e.mainImage
            } else {
              // e.mainImage = e.mainImage.replace('http://', 'https://')
              console.log(e.mainImage)
            }
            */
            e.marketPrice = Number(e.marketPrice)
            e.stock = Number(e.stock)
            e.soldNum = Number(e.soldNum)
            e.mainImageArr = []
            e.mainImageArr.push(e.mainImage)
            // 负库存下单：默认开启（后端未返回字段时保持开启）
            if (e.allowNegativeStock === undefined || e.allowNegativeStock === null || e.allowNegativeStock === '') {
              e.allowNegativeStock = 1
            }
            // e.skuList.forEach(it => {
            //   it.skuNo = e.goodsNo + it.skuNo
            // })
          })
          this.list = res.data.list
          this.page.totalNum = res.data.totalNum
        } else {
          console.log('goodsPageList - 失败', type)
        }
        this.loading = false;
        this.getCountGroupByStatus(params)// 获取商品列表数量统计
      }).catch((err) => {
        this.loading = false;
        console.log(err)
      })
    },
    // 负库存下单：统一将各种形态转为 boolean
    getNegativeStockEnabled(row) {
      const v = row && row.allowNegativeStock
      if (v === 0 || v === null || v === false) return false
      return true
    },
    async onToggleNegativeStock(row, nextEnabled) {
      // 组合商品不允许操作
      if (row.combinationCode) return

      const prev = this.getNegativeStockEnabled(row)
      // 无变化直接返回
      if (prev === nextEnabled) return

      // 关闭时二次确认（避免误操作导致不可下单/下架）
      if (nextEnabled === false) {
        try {
          await this.$confirm('关闭后：当可用库存为0时该商品不可下单，并视为已下架。是否确认关闭？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
        } catch (e) {
          // 取消：把 UI 状态回滚
          this.$forceUpdate()
          return
        }
      }

      // 先乐观更新
      row.allowNegativeStock = nextEnabled ? 1 : 0
      try {
        const res = await this.$api.goodsSetNegativeStock({
          goodsId: row.id,
          allowNegativeStock: row.allowNegativeStock
        })
        if (res.code !== 0) {
          throw new Error(res.msg || '保存失败')
        }

        // 关闭且库存<=0：前端主动触发下架（后端若已自动处理也不影响）
        if (nextEnabled === false && Number(row.stock) <= 0) {
          await this.$api.goodsPutOff({ ids: [row.id] })
        }

        this.$message({ type: 'success', message: '设置成功' })
        this.fetchData()
      } catch (err) {
        // 回滚
        row.allowNegativeStock = prev ? 1 : 0
        this.$forceUpdate()
        this.$message({ type: 'error', message: err && err.message ? err.message : '设置失败' })
      }
    },
    resetSearch() {
      this.$refs.searchForm.resetFields();
      this.combinedSearchItems.forEach(item => {
        item.keyword = '';
      })
    },
    handleCurrentChangeDialog(currentChange) {
      this.dialog.pageNo = currentChange
      this.goodsPlatformPrice()
    },
    handleSizeChangeDialog(sizeChange) {
      this.dialog.pageSize = sizeChange
      this.goodsPlatformPrice()
    },
    handleCurrentChange(currentChange) {
      this.page.currentPage = currentChange
      this.fetchData()
    },
    handleSizeChange(sizeChange) {
      this.page.pageSize = sizeChange
      this.page.currentPage = 1
      this.fetchData()
    },
    getButtonTreeDto() {
      // 获取权限设定
      this.limits = JSON.parse(sessionStorage.getItem('limit'))
      const params = this.limits.buttonTreeDto.filter(
        (item) => item.menuCode === 'companyCode'
      )
      params[0].buttonList.forEach((item) => {
        this.parArray.push(item.code)
      })
    },
    // 获取字典数据
    getDictionaries(type) {
      if (type && this.dictionaries[type].length > 0) { return }
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries[type] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取商品列表数量统计
    getCountGroupByStatus(val) {
      // const params = {}
      val.status = ''
      this.$api.countGroupByStatus(val).then((res) => {
        this.countGroupByStatus = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取类目列表
    getCategoryList() {
      const params = {}
      this.$api.categoryList(params).then((res) => {
        this.categoryList = res.data.list
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取 品牌 列表
    getBrandList() {
      const params = { pageNo: 1, pageSize: 999 }
      this.$api.brandCommList1().then((res) => {
        this.brandList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    goodsPlatforms() {
      const params = {
        ids: this.selectionId,
        userId: null,
        username: null,
        phone: null,
        vipLevel: null,
        categoryIds: this.cIds,
        openTimeStart: null,
        openTimeEnd: null,
        status: 1
      }
      this.$api.goodsPlatforms(params).then((res) => {
        // this.brandList = res.data.list
        this.platformList = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 搜索 选择 类目
    onChangeCategory(val) {
      // this.search.classId = val[val.length -1]
      // console.log(val, this.search.classId)
    },
    // 切换当前列表
    onChangeList(state) {
      this.page = { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1 }
      this.currentStatus = state
      // if ( this.currentStatus === this.assignStatus.all) {}
      if (this.currentStatus === this.groupByStatus.total) { this.fetchData('all') }
      if (this.currentStatus === this.groupByStatus.up) { this.fetchData('up') }
      if (this.currentStatus === this.groupByStatus.down) { this.fetchData('down') }
    },
    // // 多选
    // onMultipleSelection(val) {
    //   this.selectionGoods = val
    // },
    // 上架、下架
    async operationStatus(type, row) {
      this.isIndeterminate = false;
      this.checkAll = false
      this.dialog.platformIds = []
      this.selectionId = []
      this.cIds = []
      this.dialog.platformId = []
      this.selectionGoods.forEach(e => {
        this.selectionId.push(e.id)
        this.cIds.push(e.categoryId)

      })
      if (this.selectionId.length == 0) {
        this.$message({ type: 'error', message: '请选择选择商品!' })
      } else {
        this.isShow = true
        let type1 = 0
        if (type == 'up') {
          this.title = '批量上架'
          type1 = 1
        } else {
          this.title = '批量下架'
          type1 = 0
        }
        let data = {
          goodsIds: this.selectionId,
          status: type1
        }
        this.platformList = []
        this.$api.goodsPlatformStatus2(data).then((res) => {
          if (res.code == 0) {
            this.platformList1 = res.data
          }
        })
        // this.goodsPlatforms()
      }

      // return
      // console.log(type, row)
      // let msg = type === 'up' ? `是否上架商品, 是否继续?` : `是否下架商品, 是否继续?`
      // const params = { ids: [] }
      // const selectionId = []
      // const titleArr = []
      // const selectionGoods = this.selectionGoods
      // selectionGoods.forEach(e => { selectionId.push(e.id) })
      // if (row) {
      //   this.dialog.row = row
      //   params.ids.push(row.id)
      //   titleArr.push(row.name)
      //   msg = type === 'up' ? `是否上架【${row.name}】, 是否继续?` : `是否下架【${row.name}】, 是否继续?`
      // } else {
      //   this.list.forEach(e => {
      //     selectionId.forEach(s => {
      //       if (e.id === s) {
      //         titleArr.push(e.name)
      //       }
      //     })
      //   })
      //   params.ids = selectionId

      // }
      // // console.log(selectionId.length, type, selectionId)
      // if (params.ids.length === 0) { return this.$message({ type: 'error', message: '需要选择商品!' }) }

      // if (type === 'up') {
      //   const findObj = selectionGoods.find(e => { return e.status === 1 })
      //   if (findObj) { return this.$message({ type: 'error', message: '已有商品上架!' }) }
      // }
      // if (type === 'down') {
      //   this.$api.giftListByGoodId(params.ids).then((res) => {
      //     if (res.data.length > 0) {
      //       this.giftListByGoodId = res.data
      //       return this.showModifyState(type, titleArr)
      //     } else {
      //       return this.onUpDownOperation(type, params, msg)
      //     }
      //   }).catch((err) => {
      //     // console.log(err)
      //   })
      //   // setTimeout(() => {}, 1000)
      //   const findObj = selectionGoods.find(e => { return e.status === 0 })
      //   // if (findObj) { return this.$message({ type: 'error', message: '已有商品下架!' }) }
      // } else {
      //   this.onUpDownOperation(type, params, msg)
      // }
    },
    onUpDownOperation(type, params, msg) {
      let operationFun
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        switch (type) {
          case 'up':
            operationFun = this.$api.goodsPutOn
            // this.column = columnConsumption
            break
          // 分配记录
          case 'down':
            operationFun = this.$api.goodsPutOff
            break
          // default:
        }
        operationFun(params).then((res) => {
          this.fetchData()
          this.$message({ type: 'success', message: '操作成功!' })
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    showModifyState(skuList, titleArr) {
      // console.log('showModifyState', skuList, titleArr)
      this.setCloseOrder = ''
      this.dialog.visible = true
      this.dialog.title = '下架提示'
      this.dialog.width = '640px'
      this.dialog.type = 'modifyState'
      // this.dialog.row = row
      this.dialog.titleArr = titleArr
      // this.dialog.list = row.skuList
      // this.cancelOrderId = row.orderId
      // console.log('getGoodCopySku', this.dialog.list)
    },
    // 根据商品id,获取礼包列表查询接口
    onGiftListByGoodId(ids) {
      // const params = { goodsIds: ids }
      this.$api.giftListByGoodId(ids).then((res) => {
        console.log(res)
        return res
      }).catch((err) => {
        // console.log(err)
        return res
      })
    },
    // 删除商品
    onGoodsDelete(row) {
      const msg = `此操作将删除【${row.name}】, 是否继续?`
      this.$confirm(msg, '提示', {
        title: '删除商品',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        const params = { id: row.id }
        this.$api.goodsDelete(params).then((res) => {
          this.fetchData()
          this.$message({ type: 'success', message: '操作成功!' })
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    toOtherPages(name, parameter, type) {
      let query = {}
      if (name === 'goodsCategoryEdit' && type === 'add') {
        query = { from: parameter }
      } else if (name === 'goodsEdit' && type === 'edit') {
        query = { id: parameter, type }
      } else {
        query = { id: parameter, type }
      }
      this.$router.push({ name, query })
    },
    // 获取 商品 KSU
    getGoodCopySku(skuList, row) {
      this.setCloseOrder = ''
      this.dialog.visible = true
      this.dialog.title = '复制SKU码'
      this.dialog.width = '640px'
      this.dialog.type = 'skuList'
      this.dialog.list = row.skuList
      // this.cancelOrderId = row.orderId
      // console.log('getGoodCopySku', this.dialog.list)
    },
    // 复制 KSU
    onCopySku(info) {
      // console.log('onCopySku', info)
      const t = this
      this.$copyText(info).then(
        function (e) {
          t.$message({
            type: 'success',
            message: '复制成功'
          })
        },
        function (e) {
          t.$message({
            type: 'warning',
            message: '复制失败'
          })
        }
      )
    },
    // 判断导出方式
    handleBatchOperation(command) {
      if (command === 'normal') {
        this.onGoodsExport();
      } else if (command === 'cost') {
        this.onGoodsExportCost();
      }
    },
    // 商品导出
    onGoodsExport() {
      this.GoodsExportLoading = true
      let params = {
        pageNo: this.page.currentPage,
        pageSize: this.page.pageSize,
        status: this.currentTab
      }
      params = Object.assign(params, this.searchForm)
      // 类目id
      const tempCategoryIdArr = [].concat(params.categoryId)
      if (tempCategoryIdArr && tempCategoryIdArr.length !== 0) {
        params.categoryId = tempCategoryIdArr[tempCategoryIdArr.length - 1]
      }
      for (const item in params) {
        if (typeof params[item] === 'string') {
          params[item] = params[item].trim()
          if (params[item] === '') { delete params[item] }
        }
      }
      if (this.selectionGoods && this.selectionGoods.length > 0) {
        params.idList = this.selectionGoods.map(e => e.id)
      }

      this.$api.goodsExport(params).then((res) => {
        this.GoodsExportLoading = false
        this.downloadlink(res.data)
        this.$message.success('操作成功！')
      }).catch((err) => {
        this.GoodsExportLoading = false
        console.log(err)
      })
    },
    onGoodsExportCost() {

    }
  }
}
</script>

<style scoped lang="scss">
.container {
  padding: 10px;
}

.breadcrumb {
  margin-bottom: 10px;
}

.table {
  background: #fff;
  border-radius: 4px;
  padding: 10px;
}

.btnBox {
  padding: 10px 10px;
  display: flex;
  justify-content: space-between;
  background-color: #ffffff;
  margin: 0 -10px;

  /deep/ {
    .el-form-item__content {
      line-height: 28px;
    }

    .el-input__suffix {
      height: 28px;
    }

    .el-input-group__prepend {
      width: 90px;
      padding: 0 12px 0 10px;
      box-sizing: border-box;

      .el-input__inner {
        padding: 0 10px 0 7px;
        text-align: left;
      }
    }

    .el-input__inner {
      padding: 3px 8px 0;
      height: 24px;
      line-height: 24px;
      border-radius: 0;
      width: 120px;
    }

    .group-con-form {

      .el-input--mini,
      .el-cascader--mini {
        width: 180px;
      }

      .el-input__inner {
        text-align: left;
        padding: 0 10px 0 8px;
        max-width: 180px;
      }
    }
  }
}

/* 下拉框组样式 */
.input-with-select {
  display: flex;
  align-items: center;

  .prepend-text {
    width: 70px;
    flex-shrink: 0;
    background-color: #F5F7FA;
    border: 1px solid #DCDFE6;
    border-right: none;
    font-size: 12px;
    color: #909399;
    font-family: Arial;
    height: 24px;
    line-height: 24px;
    box-sizing: border-box;
    padding: 0 0 0 6px;
  }

  .category-select {
    ::v-deep .el-input__inner {
      font-weight: 400;
      font-size: 12px;
      color: #7F7F7F;
      width: 110px;
      border-radius: 0;
      border-right: none;
      background-color: #F5F7FA;
      height: 24px;
      line-height: 24px;
    }

    ::v-deep .el-select__caret {
      line-height: 24px;
    }
  }

  .el-cascader,
  .el-select {
    ::v-deep .el-input__inner {
      height: 24px;
      line-height: 24px;
      width: 120px;
    }
  }
}

/* 选项文本溢出时显示省略号 */
.category-option,
.value-option {
  ::v-deep .el-select-dropdown__item {
    span {
      font-weight: 400;
      font-size: 12px;
      color: #7F7F7F;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}

.form-buttons {
  /deep/ .el-form-item__content {
    width: 100%;
  }
}

.button-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
}

.button-group {
  display: flex;
  gap: 10px;
  align-items: center;

  &.left-group {
    justify-content: flex-start;

    .el-button {
      height: 24px;
      padding: 0 12px;
      line-height: 22px;
      font-size: 12px;

      &.is-plain {
        background-color: #ffffff;
      }
    }
  }

  &.right-group {
    justify-content: flex-end;

    .el-checkbox {
      margin-bottom: 0;

      .el-checkbox_label {
        font-size: 12px;
        color: #606266;
      }
    }
  }
}

// 确保表单项不会额外增加间距
.btnBox /deep/ .el-form-item {
  margin-bottom: 8px;
}

// 特别针对按钮表单项进行调整
.form-buttons /deep/ .el-form-item__content {
  line-height: normal;
}

/deep/.cell {
  color: #333;
}

.btn-list {
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;

  .tab-buttons {
    display: inline-flex;
    background: #fff;

    overflow: hidden;
    height: 32px;

    .tab-button {
      border-bottom: 1px solid #DCDFE6;
      padding: 0 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #606266;
      background: #fff;
      transition: all 0.3s;


      // &:last-child {
      //   border-right: none;
      // }

      // &:hover {
      //   color: #409EFF;
      //   background: #F5F7FA;
      // }

      &.active {
        background: #fff;
        color: #409EFF;
        font-weight: 500;
        position: relative;
        border-bottom: 1px solid #409EFF;
      }
    }
  }

  .item {
    /deep/ {
      .el-button--primary.is-plain {
        background-color: #fff;
      }
      .el-button--primary.is-plain:hover {
        background-color: #409EFF;
      }
    }
    .el-button {
      height: 28px;
      line-height: 26px;
      padding: 0 8px;
      font-size: 12px;
      border-radius: 4px;
    }
  }
}

// 表格样式调整
/deep/ .el-table {
  .el-table__header-wrapper,
  .el-table__body-wrapper {
    .cell {
      font-size: 12px;
      color: #333;

    }
  }

  th.el-table__cell .cell {
    height: 24px;
  }

  .el-table__body-wrapper {
    .el-table__row {
      .cell {
        .el-link {
          font-size: 12px;
          margin: 0 4px;
        }
      }
    }
  }
}

/deep/ {
  .lb-table-mini .el-table th.el-table__cell .cell {
    height: 24px;
  }

  .el-table tr {
    height: 28px;
  }
}

// 成功和危险状态样式
.success {
  color: #67C23A;
}

.danger {
  color: #F56C6C;
}

// 操作链接样式
/deep/ .el-link--inner {
  font-size: 12px;
}

// 图片样式
/deep/ .el-image {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  overflow: hidden;
}

// 分页样式
/deep/ .el-pagination {
  padding: 10px 0;
}

.popIn {
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;

    .cancel {
        width: 120px;
        height: 36px;
        border: 1px solid #d9d9d9;
        opacity: 1;
        border-radius: 4px;
    }

    .affirm {
        width: 120px;
        height: 36px;
        background: #4168e7;
        opacity: 1;
        border-radius: 4px;
    }
}
</style>
